import type { FaireProductEntity } from "../../entity_types/product";

export const p_dxd26vp7jw: FaireProductEntity = {
  token: "p_dxd26vp7jw",
  type: "product",
  name: "Glitter Dumpling Shape Squishy Stress Relief Toy with Steamer",
  brandToken: "b_da2f4yq87r",
  brandName: "Liffy",
  imageUrl:
    "https://cdn.faire.com/fastly/38abcf7d362fd76589c06b2239c915393133dc6d907308cbaf79276df8102299.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a37ac1b00fab60fbfe99c18afb4566ff8a02899b9cbfe646d6f03a3ef7597044.jpeg",
    "https://cdn.faire.com/fastly/da1b9daa0478a148f940eca983903a66661fbba2c1c875947a7ff8c40e3a88fa.jpeg",
    "https://cdn.faire.com/fastly/7d0c29739e8d3c49efeef186db1cd4a8cdefdcc95bf6e30391f1e531c549178a.jpeg",
    "https://cdn.faire.com/fastly/e0771d4cda8ce5a8227c5c6a212b5f0cc6ca3f178e2f107eafd81f174ba27c04.jpeg",
  ],
  priceDollars: 5.3,
  description:
    "Cute Dumpling Shape Design\n Features a playful dumpling shape with adorable emoji expressions and a matching steamer container, perfect for eye-catching retail display.\n\n Glitter Clear Shell Effect\n Designed with a transparent outer layer and subtle glitter inside, creating a unique visual look and satisfying squeeze feel.\n\n Soft TPR Squeeze Material\n Made from flexible TPR material that is easy to squeeze and slowly returns to shape, ideal for stress relief and fidget use.\n\nDisplay Ready Packaging\n Each piece comes with a steamer-style container, making it perfect for shelf display and gift-ready presentation.\n\nWholesale Case Pack\n Sold in a case pack of 12 pieces per box, ideal for boutiques, gift shops, and novelty stores.\n\n Size & Weight\n Dumpling size: approx. 3.35 inches (8.5 cm)\n Steamer size: approx. 3.74–3.86 inches (9.5–9.8 cm)\n Weight: approx. 230g per piece\n\nThis product features a generic no brand design and is not affiliated with any licensed or trademarked brand.\nPlease note that minor wear or damage to the outer packaging may occur during transit. This does not impact the product’s quality or usability.\nIf packaging condition is critical for your store display, please contact us before placing your order.\n",
  tags: [],
  msrpDollars: 10.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:49.997Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
